import { COSELLER_MIC_COPY, WATCHER_COPY } from './watchSession';

/**
 * The live session header in the left panel (owner, 2026-10-07). The same two
 * rows on the web, macOS (`BotLifecycle`) and WPF (`BotLifecycleLogic`):
 *   row 1: ● Live : {session name}
 *   row 2: Started at: 10:14 AM · 12:34
 */
export const LIVE_SESSION_HEADER_COPY = {
  live: 'Live',
  nameSeparator: ' : ',
  startedAt: 'Started at:',
  elapsedSeparator: ' · ',
} as const;

/** The running counter ticks once a second. */
export const LIVE_SESSION_HEADER_TICK_MS = 1_000;

/**
 * Who the signed-in user is on the live call: its owner, a co-seller with their
 * own mic on someone's desktop call, or an observer (a watcher of a desktop or
 * bot call). Row 1 names it (co-seller join redesign, owner 2026-10-07).
 */
export const LIVE_VIEWER_ROLE = {
  owner: 'owner',
  coSeller: 'coSeller',
  observer: 'observer',
} as const;

export type LiveViewerRole = (typeof LIVE_VIEWER_ROLE)[keyof typeof LIVE_VIEWER_ROLE];

/** Row 1's label: the owner's is unchanged ("Live"); the others take its place. */
export const LIVE_SESSION_HEADER_LABEL: Record<LiveViewerRole, string> = {
  [LIVE_VIEWER_ROLE.owner]: LIVE_SESSION_HEADER_COPY.live,
  [LIVE_VIEWER_ROLE.coSeller]: COSELLER_MIC_COPY.headerLabel,
  [LIVE_VIEWER_ROLE.observer]: WATCHER_COPY.headerLabel,
};
